import { Fragment, memo, PropsWithChildren } from "react";
import { STUDIO_TOOLBAR_HEIGHT } from "../../../components/StudioToolbar/StudioToolbar";
import { createStyles, palette, spacing, theme } from "../../../styles/theme";
import { useThemeBreakpoints } from "../../../utils/themeUtils";
import { Box, FlexColBox } from "../Box";
import { OverlayScrollbarWrapper } from "../OverlayScrollbar";
import { useStudio } from "../../../context/Studio";
const styles = createStyles({
  wrapper: {
    height: "100%",
    maxHeight: { xs: "initial", lg: `calc(100vh - ${STUDIO_TOOLBAR_HEIGHT})` },
    "&>div": {
      height: "100%",
      minHeight: { xs: "auto", lg: `calc(100vh - ${STUDIO_TOOLBAR_HEIGHT})` },
      [theme.breakpoints.down("lg")]: {
        overflow: "hidden",
        paddingBottom: "60px",
      },
    },
  },
  container: {
    minWidth: { xs: "100%", lg: "300px" },
    maxWidth: { xs: "100%", lg: "300px" },
    minHeight: "fit-content",
    height: "100%",
    overflowX: "hidden",
    borderLeft: { xs: "none", lg: `1px solid ${palette.grey.lightGrey}` },
    pb: { xs: spacing.regularMobile, lg: 0 },
  },
  contentWrapper: {
    p: { xs: "0", lg: "16px" },
    gap: { xs: spacing.wrapperMobile, lg: spacing.regularDesktop },
  },
});

const RightSidebar = ({ children }: PropsWithChildren) => {
  const { isMobile } = useThemeBreakpoints();
  const { isDesignLocked } = useStudio();
  const Wrapper = isMobile ? Fragment : OverlayScrollbarWrapper;
  return (
    <Box sx={styles.wrapper}>
      <Wrapper>
        <Box
          sx={[
            styles.container,
            {
              pointerEvents: {
                xs: "auto",
                lg: isDesignLocked ? "none" : "auto",
              },
            },
          ]}
        >
          <FlexColBox sx={styles.contentWrapper}>{children}</FlexColBox>
        </Box>
      </Wrapper>
    </Box>
  );
};

export default memo(RightSidebar);
